import React, { useEffect } from 'react';

export default function MaintainPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="container">
            <div className="row justify-content-center mt-5">
                <div className="col-md-8">
                    <div className="text-center">
                        <h1 className="maintainance-title">Site Under Maintenance</h1>
                    </div>
                    <div className="text-center mt-4">
                        <img src="/assets/image/maintain.png" className="img-fluid" alt="Alternate Text" />
                    </div>
                </div>
            </div>
        </div>

        {/* Emergency contact information */}
      <div className="emergency-contact">
            <p>If any Emergency Contact:</p>
            <b>(306) 559-3228</b> <br />
            <b>(306) 559-3428</b>
      </div>
    </>
  );
}
